import storeutilis from '@/helpers/storeutilis';

export default {
	// Notices
    errors: state => {
        return state.errors;
    },
    notices: state => {
        return state.notices;
    },



	// Datas
    channel: state => {
    	// if(!isCacheValid(state.channel.time)) return false;
        return state.channel;
    },
    channels: state => {
    	// if(!state.channel || !isCacheValid(state.channel.time)) return false;
        return state.channels;
    },
    user: state => {
        return state.user;
    },
    edituser: state => {
        return state.edituser;
    },

    // statussen
    slimnavigation: state => {
        return state.slimnavigation;
    },
    loading: state => {
    	let isLoading = false;
    	Object.keys(state.loading).forEach(function(name){
    		if(!isLoading && state.loading[name]) isLoading = true;
    	});
        return isLoading;
    },
    loadings: state => {
        return state.loading;
    },
    saveing: state => {
        return state.saveing;
    },
    editing: state => {
        return state.edting;
    },
    changed: state => {
        return state.changed;
    },
    devmode: state => {
        return state.devmode;
    },


  	getEditFieldById: (state, getters) => (name) => {

    	if(getters.edituser && getters.edituser.fields) {
    		return storeutilis.getUsereditFieldById(getters.edituser.fields, name);
    	}

    	if(getters.presentation && getters.presentation.form_fields) {
    		return storeutilis.getUsereditFieldById(getters.presentation.form_fields, name);
    	}

    	if(getters.channel && getters.channel.page) {
    		return storeutilis.getUsereditFieldById(getters.channel.page, name);
    	}

    	return false;
  	},



    mouseposition: state => {
        return state.mouseposition;
    },
};



// WEBPACK FOOTER //
// ./src/store/getters.js